import { Component, OnInit, HostListener, ViewChild } from '@angular/core';


import { Router, NavigationEnd } from '@angular/router';

import { SnotifyService } from 'ng-snotify';
import { HttpClient } from '@angular/common/http';
import { Config } from '../../../../../../config/config';
import { SharedDataService } from '../../../../../../service/shared-data.service';
import { RestDataService } from '../../../../../../service/rest-data.service';
import { StaticDataService } from '../../../../../../service/static-data.service';

@Component({
  selector: 'liteHeader',
  templateUrl: './lite-header.component.html',
  styleUrls: ['./lite-header.component.scss']
})
export class LiteHeaderComponent implements OnInit {
  storyFLag: string;
  publishButtonFlag = false;
  changesFlag = true;
  shownav: string;
  headerPageBtn = false;
  pageName = 'storyheader';
  publishCommand: string;
  domain: string;
  GAEventString = '';
  openShortcutsPreview = false;
  openSendNotificationPopup = false;
  SingleselectedFile: File = null;
  showCropper = false;
  cropperImageUrl = {
    url: null,
    data: null
  };
  storyData: any;
  currentImageData: any;
  loaded: boolean;
  socialMap = {
    mobile: false,
    web: false
  };
  embedSourceUrl = '';
  notificationHeadLine = '';
  showLoader = false;
  domainConfig: any;
  saveFlag = false;
  closeFlashNotificationTimer = null;
  croppingInProgress = false;
  disabledStoryTypes = [];
  sendingNotification = false;
  elementsDisabled = false;
  breakingNewsPopup = false;
  breakingNewsListingPopup = false;
  notificationUrl = '';
  pagesDisabled = [];
  openNotificationPopup = false;
  applicationDropdownSettings = {};
  segmentDropdownSettings = {};
  moSegmentDropdownSettings = {};
  notificationTypeDropdownSettings = {};
  tagDropdownSettings = {};
  tags:any = [];
  segments:any = [];
  applications:any = [];
  deviceType: string = 'Web';
  notificationType:any = [];
  selectedApplications = [];
  devices: string[];
  selectedSegments = [];
  currentSegmentIds: string[];
  currentMoSegmentIds: string[];
  selectedTags = [];
  currentTagIds: string[];
  notification: any = {};
  selectedNotificationType : any = [];
  selectedNotificationTypeObject: any = {};
  mandatoryFieldUrl = false;
  mandatoryImageUrl = false;
  mandatoryFieldStoryId = false;
  mandatoryFieldMessage = false;
  statusMenu:boolean = false;
  openSegmentPopup = false;
  newSegment = '';
  mandatoryFieldSegment = false;
  moSegments:any = [];
  selectedMoSegments:any = [];
  moEngaeRespponse = false;
  webEngageResponse = false;
  enableWebEngage = false;
  enableMoEngage = false;
  enableCrossDomainNotification = false;
  crossDomainDropdownSettings = {};
  currentCrossDomainIds: string[];
  crossDomains:any =[];
  selectedCrossDomains:any = [];
  crossDomainRespponse = false;
  enableRestoreVersionButton = false;
  pageNavigationList:any;
  checkingPlag: boolean;
  pageAccess:"";
  elementAccess:"";
  enableElementCreate:boolean = false;;
  constructor(
    public config: Config ,
    public sharedService: SharedDataService,
    private snotify: SnotifyService,
    private http: HttpClient,
    private restService: RestDataService,
    private router: Router
  ) {
    
    this.domain = sessionStorage.getItem(StaticDataService.domainLiteral);
    this.sharedService.getCurrentDomainConfig(this.getDomainConfig.bind(this));
    this.applicationDropdownSettings = this.sharedService.getDropDownSettings(false, 'id', 'name');
    this.segmentDropdownSettings = this.sharedService.getDropDownSettings(false, 'id', 'name');
    this.moSegmentDropdownSettings = this.sharedService.getDropDownSettings(false, 'id', 'name');
    this.moSegmentDropdownSettings['singleSelection'] = true;
    this.crossDomainDropdownSettings = this.sharedService.getDropDownSettings(false, 'id', 'name');
    this.notificationTypeDropdownSettings = this.sharedService.getDropDownSettings(true, 'id', 'name');
    this.tagDropdownSettings = this.sharedService.getDropDownSettings(false, 'id', 'tagName');
    this.enableWebEngage = this.sharedService.isdomainConfig('story','enableWebEngage');
    this.enableMoEngage = this.sharedService.isdomainConfig('story','enableMoEngage');
    this.enableCrossDomainNotification = this.sharedService.isdomainConfig('story','enableCrossDomainNotification');
    /*if(this.sharedService.currentDomainConfiguration && this.sharedService.currentDomainConfiguration['notificationPlatformsEnabled'].indexOf('webengage') > -1){
        this.fetchApplications();
        this.fetchSegments();
        this.fetchMoSegments();
        this.fetchCrossDomains();
        this.fetchTags();
        this.fetchNotificationType();
    }*/
    // console.log(this.domain, this.domainConfig, conf);
  }

  getDomainConfig(currentDomainConfig) {
    // console.log(currentDomainConfig);
    this.domainConfig = currentDomainConfig;
    this.disabledStoryTypes = this.domainConfig['disabledStoryType'];
    this.elementsDisabled = this.domainConfig['elementsDisabled'];
    this.pagesDisabled = this.domainConfig['pagesDisabled'] || [];
    //required in the string form
    this.pageNavigationList= this.domainConfig['config']&& this.domainConfig['config']['pages'] && this.domainConfig['config']['pages']['pageNavigationList']?JSON.parse(this.domainConfig['config']['pages']['pageNavigationList']):undefined;
  }

  ngOnInit() {
    const currentDomain = sessionStorage.getItem(StaticDataService.domainLiteral);
    this.restService.tokenParse();
    if(this.restService.userDetail.domainPermissions[currentDomain].elementPermissions)
    { 
      this.elementAccess = this.restService.userDetail.domainPermissions[currentDomain].elementPermissions.accessType;
    }
    console.log("Element Access Type: "+this.elementAccess);
    if(!this.elementAccess || this.elementAccess === "Edit")
    {
      this.enableElementCreate = true;
    }
    console.log(this.enableElementCreate);

    if(this.restService.userDetail.domainPermissions[currentDomain].pagePermissions)
    { 
      this.pageAccess = this.restService.userDetail.domainPermissions[currentDomain].pagePermissions.accessType;
    }
    console.log("Page Access Type: "+this.pageAccess);

    this.checkRoute();
    this.router.events.subscribe((val) => {
      if (val instanceof NavigationEnd) {
        this.checkRoute();
        this.closeBreakingNewsListing();
        this.closeBreakingNews();
        this.closesendFlashNotifications();
        this.closesendNotifications();
      }
    });
    this.sharedService.getData().subscribe(x => {
      if (x === 'publish_disable|true') {
        this.publishButtonFlag = true;
      } else if (x === 'publish_disable|false') {
        this.publishButtonFlag = false;
      }
      if (x === 'saved|true') {
        this.changesFlag = true;
      } else if (x === 'saved|false') {
        this.changesFlag = false;
      }
      if (x === 'saveFlag|true') {
        this.saveFlag = true;
      } else if (x === 'saveFlag|false') {
        this.saveFlag = false;
      }
      if (x === 'checkingPlag|true') {
        this.checkingPlag = true;
      } else if (x === 'checkingPlag|false') {
        this.checkingPlag = false;
      }
      if (x === 'key27') {
        this.closePreviewShortcuts();
        this.closeBreakingNewsListing();
        this.closeBreakingNews();
        this.closesendFlashNotifications();
        this.closesendNotifications();
      }
    });
    this.currentImageData = null;
  }

  openPreviewShortcuts(itemShortcut) {
    this.openShortcutsPreview = true;
    this.sharedService.overflowhidden();

  }
  closePreviewShortcuts() {
    if (this.openShortcutsPreview) {
      this.openShortcutsPreview = false;
      this.sharedService.overflowauto();

    }
  }

  sendSaveRequest(obj) {
   this.sharedService.sendData('manual-save');
  }
  sendPublishCommand(obj) {
    if (obj === 'story') {
      this.sharedService.sendData('publish');
    } else if (obj === 'page') {
      this.sharedService.sendData('pagePublish');
    } else if (obj === 'element') {
      this.sharedService.sendData('elementPublish');
    } else if (obj === 'pageNav') {
      this.sharedService.sendData('pageNavPublish');
    } 
    else if (obj === 'topNav') {
      this.sharedService.sendData('topNavPublish');
    }
    else if (obj === 'l1') {
      this.sharedService.sendData('l1NavPublish');
    }
    else if (obj === 'l2') {
      this.sharedService.sendData('l2NavPublish');
    }
    else if (obj === 'l3') {
      this.sharedService.sendData('l3NavPublish');
    }
  }
  checkRoute() {
    if (this.router.routerState.snapshot.url.indexOf('story') < 0) {
      this.closePreviewShortcuts();
    }
    if (this.router.routerState.snapshot.url.indexOf('story') > -1) {
      this.storyFLag = 'story';
      this.shownav = '';
      this.GAEventString = '';
    } else if (this.router.routerState.snapshot.url.indexOf('web-stories') > -1) {
      this.storyFLag = 'story';
      this.shownav = '';
      this.GAEventString = '';
    } else if (this.router.routerState.snapshot.url.indexOf('pages') > -1) {
      this.pageName = 'pageheader';
      this.storyFLag = 'dash';
      this.shownav = 'nav';
      this.GAEventString = 'page';
    } else if (this.router.routerState.snapshot.url.indexOf('users') > -1) {
      this.pageName = 'userManagement';
      this.storyFLag = 'dash';
      this.GAEventString = '';
    } else if (this.router.routerState.snapshot.url.indexOf('elements') > -1) {
      this.pageName = 'elementheader';
      this.storyFLag = 'dash';
      this.shownav = '';
      this.GAEventString = 'element';
    } else if (this.router.routerState.snapshot.url.indexOf('page') > -1) {
      this.shownav = '';
      this.GAEventString = '';
      if (this.router.routerState.snapshot.url.indexOf('nav-manager') > -1 ||
        this.router.routerState.snapshot.url.indexOf('footer-manager') > -1) {
        this.storyFLag = 'pageNav';
      } else {
        this.storyFLag = 'page';
      }
    } else if (this.router.routerState.snapshot.url.indexOf('element') > -1) {
      this.shownav = '';
      this.storyFLag = 'element';
      this.GAEventString = '';
    } 
    else if (this.router.routerState.snapshot.url.indexOf('nav-manager/topnav') > -1 ||
      this.router.routerState.snapshot.url.indexOf('footer-manager/topnav') > -1) {
      this.shownav = '';
      this.storyFLag = 'topNav';
      this.GAEventString = '';
    } 
    else if (this.router.routerState.snapshot.url.indexOf('nav-manager/l1') > -1) {
      this.shownav = '';
      this.storyFLag = 'l1';
      this.GAEventString = '';
    } 
    else if (this.router.routerState.snapshot.url.indexOf('nav-manager/l2') > -1) {
      this.shownav = '';
      this.storyFLag = 'l2';
      this.GAEventString = '';
    } 
    else if (this.router.routerState.snapshot.url.indexOf('nav-manager/l3') > -1) {
      this.shownav = '';
      this.storyFLag = 'l3';
      this.GAEventString = '';
    } 
    else if (this.router.routerState.snapshot.url.indexOf('template') > -1) {
      this.shownav = '';
      this.storyFLag = 'template';
      this.GAEventString = '';
    } else if (this.router.routerState.snapshot.url.indexOf('videos') > -1) {
      this.shownav = '';
      this.storyFLag = 'video';
      this.GAEventString = '';
    } else if (this.router.routerState.snapshot.url.indexOf('users') > -1) {
      this.shownav = '';
      this.storyFLag = 'video';
      this.GAEventString = '';
    }  else {
      this.storyFLag = 'dash';
      this.pageName = 'storyheader';
      this.shownav = '';
      if (this.router.routerState.snapshot.url.indexOf('workspace') > -1) {
        this.GAEventString = 'story';
      } else {
        this.GAEventString = '';
      }
    }
  }
  open_new(ur, name) {
    if(this.router.routerState.snapshot.url.indexOf('element')>-1 && !this.enableElementCreate)
    {
        this.snotify.error('You do not have permissions to create an element', '', this.sharedService.getConfig(false));
    }
    else{
    if (ur && name) {
      this.snowplowAnalytics(ur, name);
      window.open(window.location.origin + ur, '_blank');
    }
  }
  }

  snowplowAnalytics(ur, name) {
    this.sharedService.analyticsCall((window.location.origin + ur), this.GAEventString, [], name.toLowerCase().replace('create ', ''));
  }

  sendFlashNotifications() {
    this.openSendNotificationPopup = true;
    this.sendListingDisableCommand(true);
    this.sharedService.overflowhidden();
  }

  closesendFlashNotifications() {
    clearInterval(this.closeFlashNotificationTimer);
    this.sendListingDisableCommand(false);
    this.openSendNotificationPopup = false;
    this.storyData = null;
    this.currentImageData = null;
    this.notificationHeadLine = '';
    this.notificationUrl = '';
    this.SingleselectedFile = null;
    this.sendingNotification = false;
    this.socialMap = {
      mobile: false,
      web: false
    };
    this.sharedService.overflowauto();
    this.breakingNewsPopup = false;
  }

  onFileChange(event, model) {
    const reader = new FileReader();
    // console.log('file uplaod called');
    const fd = new FormData();
    this.SingleselectedFile = <File>event.target.files[0];
    // console.log(this.SingleselectedFile);
    this.showLoader = true;
    if (event.target.files && event.target.files.length > 0) {
      if ((typeof event.target.files[0]) === 'object') {
        // console.log(event.target.files[0]);
        if ((this.SingleselectedFile.size / 1000000) <= 11) {
          const a = reader.readAsDataURL(event.target.files[0]);
          reader.onload = (e: any) => {
            this.sharedService.checkImageForAMP(reader, flag => {
              if (flag) {
                this.uplaodImageAndOpenCropper(this.SingleselectedFile, e.target.result);
              } else {
                this.sharedService.showAMPConfirmPopup(() => { // yes
                  this.uplaodImageAndOpenCropper(this.SingleselectedFile, e.target.result);
                },
                  () => { // no
                    this.SingleselectedFile = null;
                    this.showLoader = false;
                  }
                );
              }
            });
          };
        } else {
          this.SingleselectedFile = null;
          this.showLoader = false;
          this.snotify.error('Image size exceeds 12 MB', '', this.sharedService.getConfig(false));
        }
      }
    }
    event.target.value = null;
  }

  uplaodImageAndOpenCropper(imageFile, base64) {
    this.snotify.info('Uplaoding', '', this.sharedService.getConfig(false));
    this.sharedService.uploadImage(imageFile).
    subscribe(res => {
        this.cropperImageUrl.data = base64;
        this.cropperImageUrl.url = res['images']['original'];
        this.showCropper = true;
    },
    error => {
      this.SingleselectedFile = null;
      this.showLoader = false;
      this.snotify.error('Upload Failed', '', this.sharedService.getConfig(false));
    });
  }

  cancelCropping() {
    this.showCropper = false;
    this.cropperImageUrl = {
      url: null,
      data: null
    };
    this.SingleselectedFile = null;
    this.showLoader = false;
  }

  finishCropping(event) {
    const requests = event.cropRequests;
    this.cancelCropping();
    this.croppingInProgress = true;
    this.sharedService.croppingSequence(requests, false, data => {
      if (!data.hasOwnProperty('error')) {
        const { ampFlag, imagemap } = data;
        const ImageCardData = JSON.parse(JSON.stringify(StaticDataService.defaultImageCardData));
        ImageCardData.domainId = sessionStorage.getItem(StaticDataService.domainLiteral);
        ImageCardData.id = null;
        ImageCardData.createdBy = JSON.parse(localStorage.getItem(StaticDataService.tokenLiteral)).user.emailId;
        ImageCardData.imageAmpValidated = ampFlag;
        ImageCardData.image.images = imagemap;
        this.restService.http_post(this.config.get('product').baseUrl
          + this.config.getEndPoint(this.config.get('views'), 'element', 'get_element'),
          ImageCardData, result => {
            this.croppingInProgress = false;
            if (result) {
              this.currentImageData = result;
            } else {
              this.snotify.clear();
              this.snotify.info('Element could not be created.', '', this.sharedService.getConfig(false));
            }
          });
      } else {
        console.log(data);
        this.croppingInProgress = false;
      }
    });
  }

  sendFlashNotification() {
    const isNotificationToBeSent = (this.socialMap && (this.socialMap.web || this.socialMap.mobile));
    if (!this.notificationHeadLine || this.notificationHeadLine.trim() === '') {
      this.snotify.error('Headlines cannot be empty.', '', this.sharedService.getConfig(false));
      return;
    } else if (!isNotificationToBeSent) {
      this.snotify.error('Select Target Application', '', this.sharedService.getConfig(false));
      return;
    }
    this.notificationLogic();
  }

  imgLoaded(load) {
    this.loaded = true;
  }

  startCropping() {
    // const imageUrl = this.sharedService.getImageOnPriority(this.currentImageData['image']['images'], 'original');
    const imageUrl = this.config.get('product').baseUrl + StaticDataService.proxyImage +
    this.sharedService.getImageOnPriority(this.currentImageData['image']['images'], 'original');
    this.sharedService.createObjectFromImageUrl(imageUrl, (data, reader) => {
      if (data !== false) {
        this.cropperImageUrl = data;
        this.showCropper = true;
        this.croppingInProgress = false;
      } else {
        this.cancelCropping();
        this.snotify.error('Image path does not exist.', '', this.sharedService.getConfig(false));
      }
    });
  }

  toggleSwitch(name) {
    this.socialMap[name] = !this.socialMap[name];
  }

  openBreakingNewsListing() {
    this.breakingNewsListingPopup = true;
    this.sendListingDisableCommand(true);
    this.closeBreakingNews();
    this.sharedService.overflowhidden();
  }

  closeBreakingNewsListing() {
    this.breakingNewsListingPopup = false;
    this.sendListingDisableCommand(false);
    this.openBreakingNews();
    this.sharedService.overflowauto();
  }

  openBreakingNews() {
    this.breakingNewsPopup = true;
    this.sendListingDisableCommand(true);
    this.sharedService.overflowhidden();
  }

  closeBreakingNews() {
    this.notificationHeadLine = '';
    this.notificationUrl = '';
    if (this.currentImageData && this.currentImageData.image && this.currentImageData.image.images) {
    this.currentImageData = null;
    }
    this.breakingNewsPopup = false;
    this.sendListingDisableCommand(false);
    this.sharedService.overflowauto();
  }

  sendBreakingNews() {
    if (!this.notificationHeadLine || this.notificationHeadLine.trim() === '') {
      this.snotify.error('Headlines cannot be empty.', '', this.sharedService.getConfig(false));
      return;
    }
    const url = this.config.get('product').baseUrl + '/api/cms/breakingnews';
    const isNotificationToBeSent = (this.socialMap && (this.socialMap.web || this.socialMap.mobile));
    const breakingData = {
      'headline': this.notificationHeadLine,
      'url': this.notificationUrl,
      'status': 'active',
      'notificationSend' : isNotificationToBeSent,
      'image': (this.currentImageData && this.currentImageData.image) ? this.currentImageData.image : null
    };
    this.restService.http_post(url, breakingData, result => {
      if (result && !result.hasOwnProperty('error')) {
        // console.log({isNotificationToBeSent});
        this.snotify.success('Breaking news added Successfully', '', this.sharedService.getConfig(false));
        if (isNotificationToBeSent) {
          this.notificationLogic();
        } else {
          this.closesendFlashNotifications();
        }
      } else {
        this.snotify.clear();
        this.snotify.info('Breaking news Failure', '', this.sharedService.getConfig(false));
      }
    });
  }


  notificationLogic() {
    this.sendingNotification = true;
    this.storyData = JSON.parse(JSON.stringify(StaticDataService.defaultStoryData));
    this.storyData.domainId = sessionStorage.getItem(StaticDataService.domainLiteral);
    this.storyData.type = 'flash';
    this.storyData.browserNotificationHeadline = this.notificationHeadLine;
    this.storyData.mobileAppNotificationHeadline = this.notificationHeadLine;
    if (this.currentImageData != null) {
      this.storyData.leadMedia.elements = [this.currentImageData.id];
      this.storyData.imageAmpValidated = this.currentImageData['ampValidated'];
    }
    let desktopNotificationSendStatus = false;
    let mobileNotificationSendStatus = false;
    if (this.socialMap.web) {
      // console.log('browser:', this.config.getEndPoint(this.config.get('views'), 'header_main', 'browser_flash'));
      this.restService.http_post(this.config.get('product').baseUrl
        + this.config.getEndPoint(this.config.get('views'), 'header_main', 'browser_flash'),
        this.storyData, result => {
          if (result.hasOwnProperty('status')) {
            if (result.status === false) {
              this.snotify.error(result.reason, '', this.sharedService.getConfig(false));
            } else {
              desktopNotificationSendStatus = true;
              this.snotify.success('Desktop Flash Notification Send', '', this.sharedService.getConfig(false));
              this.closeBreakingNews();
            }
          }
        });
    }
    if (this.socialMap.mobile) {
      this.restService.http_post(this.config.get('product').baseUrl
        + this.config.getEndPoint(this.config.get('views'), 'header_main', 'mobile_flash'),
        this.storyData, result => {
          if (result.hasOwnProperty('status')) {
            if (result.status === false) {
              this.snotify.error(result.reason, '', this.sharedService.getConfig(false));
            } else {
              mobileNotificationSendStatus = true;
              this.snotify.success('App Flash Notification Send', '', this.sharedService.getConfig(false));
              this.closeBreakingNews();
            }
          }
        });
    }
    this.closeFlashNotificationTimer = setInterval(() => {
      if (this.socialMap.web === desktopNotificationSendStatus && this.socialMap.mobile === mobileNotificationSendStatus) {
        this.closesendFlashNotifications();
      }
    }, 400);
  }

  sendListingDisableCommand(flag) {
    if (flag) {
      this.sharedService.sendData('listing_disable|true');
    } else {
      this.sharedService.sendData('listing_disable|false');
    }
  }

  sendNotifications() {
    this.openNotificationPopup = true;
    this.notification = {};
    this.notification['storyUrl'] = '';
    this.notification['storyId'] = '';
    this.notification['imageUrl'] = '';
    this.currentSegmentIds = [];
    this.currentMoSegmentIds = [];
    this.currentTagIds = [];
     this.sharedService.overflowhidden();
     if(this.applications && this.applications.length > 0){
           this.selectedApplications = this.applications;
           this.notification['appTypes'] = [];
      for (let value of this.selectedApplications) {
        this.notification['appTypes'].push(value['deviceType']);
      };
     }
     if(this.notificationType && this.notificationType.length > 0){
      this.selectedNotificationType = this.notificationType.filter(t => t.name === 'Banner');
      if(this.selectedNotificationType.length > 0){
        this.selectedNotificationTypeObject = this.selectedNotificationType[0];
      }
     }
  }
  closesendNotifications() {
    this.openNotificationPopup = false;
    this.sharedService.overflowauto();
    this.notification = {};
    this.selectedTags = [];
    this.selectedSegments = [];
    this.selectedMoSegments = []
    this.currentSegmentIds = [];
    this.currentMoSegmentIds = [];
    this.currentTagIds = [];
  }

  openCreateSegmentPopup()
  {
    this.openNotificationPopup = false;
    this.sharedService.overflowauto();
    this.openSegmentPopup = true;
    this.sharedService.overflowhidden();
  }

  closeCreateSegmentPopup()
  {
    this.openSegmentPopup = false;
    this.sharedService.overflowauto();
    this.openNotificationPopup = true;
    this.sharedService.overflowhidden();
    this.newSegment='';
  }

  createSegment()
  {
    this.mandatoryFieldSegment = false;
    if(this.newSegment === undefined ||  this.newSegment === null ||  this.newSegment=='')
    {
      console.log("segment is blank");
      this.snotify.error('Please Fill Segment Name', this.sharedService.getConfig(false));
      this.mandatoryFieldSegment = true;
    }else{
      //validate segment
      console.log("segment is submitted");
      let requestSegment = {'name':this.newSegment};
      let url = this.config.get('product').baseUrl
        + this.config.getEndPoint(this.config.get('views'), StaticDataService.header_page_id, 'create_moengage_segment');
      this.http.post(url, requestSegment).subscribe((response) => {
        this.closeCreateSegmentPopup();
        this.fetchMoSegments();
        this.snotify.success('Segment Created Successfully', '', this.sharedService.getConfig(false));
      }, (error) => {
        if(error.error && error.error.text)
        {
          this.snotify.error(error.error.text);
        }else{
          this.snotify.error('Error While Creating Segment', '', this.sharedService.getConfig(false));
        }
      });
    }
  }

  onItemSelect($event, type) {
    if (type) {
       if (type === 'application') {
        this.deviceType = '';
        this.devices = [];
        this.notification['appTypes'] = [];
        for (let value of this.selectedApplications) {
          this.deviceType = this.deviceType.concat(this.applications.filter(app => app['id'] === value['id']).map(res => res['deviceType']).toString(), ',');
          this.devices.push(value['id']);
          this.notification['appTypes'].push(value['deviceType']);
        }
       } else if (type === 'segment') {
        this.currentSegmentIds = [];
        for (let value of this.selectedSegments) {
          this.currentSegmentIds.push(value['id']);
        }
      } else if (type === 'mosegment') {
        this.currentMoSegmentIds = [];
        for (let value of this.selectedMoSegments) {
          this.currentMoSegmentIds.push(value['name']);
        }
      } else if (type === 'crossDomain') {
        this.currentCrossDomainIds = [];
        for (let value of this.selectedCrossDomains) {
          this.currentCrossDomainIds.push(value['name']);
        } 
      }else if (type === 'tag') {
        this.currentTagIds = [];
        for (let value of this.selectedTags) {
          this.currentTagIds.push(value['id']);
        }
      } else if (type === 'notificationType') {
        this.notification = JSON.parse(JSON.stringify(SharedDataService.defaultNotificationData));
        this.selectedTags = [];
        this.selectedApplications = [];
        this.selectedSegments = [];
        for (let value of this.selectedNotificationType) {
          this.selectedNotificationTypeObject = value;
          this.notification['notificationTypeId'] = value['id'];
        }
      }
    }
      
  }

  onSelectAll($event, type) {
     if (type) {
      if (type === 'application') {
      this.selectedApplications = $event;
      this.deviceType = '';
      this.devices = [];
      this.notification['appTypes'] = [];
      for (let value of this.selectedApplications) {
        this.deviceType = this.deviceType.concat(this.applications.filter(app => app['id'] === value['id']).map(res => res['deviceType']).toString(), ',');
        this.devices.push(value['id']);
        this.notification['appTypes'].push(value['deviceType']);
      }
      } else if (type === 'segment') {
        this.selectedSegments = $event;
        this.currentSegmentIds = [];
        for (let value of this.selectedSegments) {
          this.currentSegmentIds.push(value['id']);
        }
      } else if (type === 'mosegment') {
        this.selectedMoSegments = $event;
        this.currentMoSegmentIds = [];
        for (let value of this.selectedMoSegments) {
          this.currentMoSegmentIds.push(value['name']);
        }
      } else if (type === 'crossDomain') {
        this.selectedCrossDomains = $event;
        this.currentCrossDomainIds = [];
        for (let value of this.selectedCrossDomains) {
          this.currentCrossDomainIds.push(value['name']);
        }
      } else if (type === 'tag') {
        this.selectedTags = $event;
        this.currentTagIds = [];
        for (let value of this.selectedTags) {
          this.currentTagIds.push(value['id']);
        }
      } else if (type === 'notificationType') {
        this.selectedNotificationType = $event;
        this.notification = JSON.parse(JSON.stringify(SharedDataService.defaultNotificationData));
        this.selectedTags = [];
        this.selectedApplications = [];
        this.selectedSegments = [];
        for (let value of this.selectedNotificationType) {
          this.selectedNotificationTypeObject = value;
          this.notification['notificationTypeId'] = value['id'];
        }
      }
     }
  }

  onItemDeSelect($event, type) {
    if (type) {
      if (type === 'application') {
        this.deviceType = '';
        this.devices = [];
        this.notification['appTypes'] = [];
        this.restService.http_get(this.config.get('product').baseUrl
        + this.config.getEndPoint(this.config.get('views'), StaticDataService.header_page_id, 'webengage_applications')).subscribe((response) => {
            if(response){
              this.applications = response;
              for (let value of this.selectedApplications) {
                this.deviceType = this.deviceType.concat(this.applications.filter(app => app['id'] === value['id']).map(res => res['deviceType']).toString(), ',');
                this.devices.push(value['id']);
                this.notification['appTypes'].push(value['deviceType']);
              }
            }
        },(error)=>{
          console.log(error);
         // this.snotify.error('Error While fetching Applications', '', this.sharedService.getConfig(false));
        });
      } else if (type === 'segment') {
        this.currentSegmentIds = [];
        this.fetchSegments();
        for (let value of this.selectedSegments) {
          this.currentSegmentIds.push(value['id']);
        }
      } else if (type === 'mosegment') {
        this.currentMoSegmentIds = [];
        //this.fetchSegments();
        for (let value of this.selectedMoSegments) {
          this.currentMoSegmentIds.push(value['name']);
        }
      } else if (type === 'crossDomain') {
        this.currentCrossDomainIds = [];
        for (let value of this.selectedCrossDomains) {
          this.currentCrossDomainIds.push(value['name']);
        }
      }  else if (type === 'tag') {
        this.currentTagIds = [];
        this.fetchTags();
        for (let value of this.selectedTags) {
          this.currentTagIds.push(value['id']);
        }
      } else if (type === 'notificationType') {
        this.notification = JSON.parse(JSON.stringify(SharedDataService.defaultNotificationData));
        this.selectedTags = [];
        this.selectedApplications = [];
        this.selectedSegments = [];
        for (let value of this.selectedNotificationType) {
          this.selectedNotificationTypeObject = value;
          this.notification['notificationTypeId'] = value['id'];
        }
        if(this.selectedNotificationType.length === 0){
          this.selectedNotificationTypeObject = {};
        }
      }
    }
  }

  onDeSelectAll(ev, type) {
     if (type) {
       if (type === 'application') {
        this.selectedApplications = ev;
        this.deviceType = '';
        this.devices = [];
        this.notification['appTypes'] = [];
        this.restService.http_get(this.config.get('product').baseUrl
        + this.config.getEndPoint(this.config.get('views'), StaticDataService.header_page_id, 'webengage_applications')).subscribe((response) => {
            if(response){
              this.applications = response;
              for (let value of this.selectedApplications) {
                this.deviceType = this.deviceType.concat(this.applications.filter(app => app['id'] === value['id']).map(res => res['deviceType']).toString(), ',');
                this.devices.push(value['id']);
                this.notification['appTypes'].push(value['deviceType']);
              }
            }
        },(error)=>{
          console.log(error);
         // this.snotify.error('Error While fetching Applications', '', this.sharedService.getConfig(false));
        });
        
       } else if (type === 'segment') {
        this.selectedSegments = ev;
        this.currentSegmentIds = [];
        this.fetchSegments();
        for (let value of this.selectedSegments) {
          this.currentSegmentIds.push(value['id']);
        }
      }  else if (type === 'mosegment') {
        this.selectedMoSegments = ev;
        this.currentMoSegmentIds = [];
        //this.fetchSegments();
        for (let value of this.selectedMoSegments) {
          this.currentMoSegmentIds.push(value['name']);
        }
      } else if (type === 'crossDomain') {
        this.currentCrossDomainIds = [];
        for (let value of this.selectedCrossDomains) {
          this.currentCrossDomainIds.push(value['name']);
        }
      } else if (type === 'tag') {
        this.selectedTags = ev;
        this.currentTagIds = [];
        this.fetchTags();
        for (let value of this.selectedTags) {
          this.currentTagIds.push(value['id']);
        }
      } else if (type === 'notificationType') {
        this.selectedNotificationType = ev;
        this.notification = JSON.parse(JSON.stringify(SharedDataService.defaultNotificationData));
        this.selectedTags = [];
        this.selectedApplications = [];
        this.selectedSegments = [];
        for (let value of this.selectedNotificationType) {
          this.selectedNotificationTypeObject = value;
          this.notification['notificationTypeId'] = value['id'];
        }
      }
     }
  }

  fetchApplications(){
    this.http.get(this.config.get('product').baseUrl
    + this.config.getEndPoint(this.config.get('views'), StaticDataService.header_page_id, 'webengage_applications')).subscribe((response) => {
        if(response){
          this.applications = response;
          this.selectedApplications = this.applications;
        }
    },(error)=>{
      console.log(error);
     // this.snotify.error('Error While fetching Applications', '', this.sharedService.getConfig(false));
    });
  }

  fetchTags(){
    this.http.get(this.config.get('product').baseUrl
    + this.config.getEndPoint(this.config.get('views'), StaticDataService.header_page_id, 'webengage_tags')).subscribe((response) => {
        if(response && response['response'] && response['response']['data']){
          this.tags = response['response']['data'];
        }
    },(error)=>{
      console.log(error);
    //  this.snotify.error('Error While fetching Tags', '', this.sharedService.getConfig(false));
    });
  }

  fetchSegments(){
    this.http.get(this.config.get('product').baseUrl
    + this.config.getEndPoint(this.config.get('views'), StaticDataService.header_page_id, 'webengage_segments')).subscribe((response) => {
        if(response && response['response'] && response['response']['data']){
          this.segments = response['response']['data'];
        }
    },(error)=>{
      console.log(error);
     // this.snotify.error('Error While fetching Segments', '', this.sharedService.getConfig(false));
    });
  }

  fetchMoSegments(){
    this.http.get(this.config.get('product').baseUrl
    + this.config.getEndPoint(this.config.get('views'), StaticDataService.header_page_id, 'get_moengage_segments')).subscribe((response) => {
        if(response){
        //   let index = 0; 
        //   for(let item in response)
        //   {
        //     response[item]['id']=index;
        //     index++;
        //   }
          this.moSegments = response;
        }
    },(error)=>{
      console.log(error);
      // this.snotify.error('Error While fetching Segments', '', this.sharedService.getConfig(false));
    });
  }

  fetchCrossDomains(){
    this.http.get(this.config.get('product').baseUrl
    + this.config.getEndPoint(this.config.get('views'), StaticDataService.header_page_id, 'get_cross_domains')).subscribe((response) => {
      if(response){
        this.crossDomains = [];
        for(let item in response)
        {
          let obj = {};
          obj['name'] = response[item];
          obj['id'] = response[item];
          this.crossDomains.push(obj);
        }
       
      }
    },(error)=>{
      console.log(error);
      // this.snotify.error('Error While fetching Segments', '', this.sharedService.getConfig(false));
    });
  }

  fetchNotificationType(){
    this.http.get(this.config.get('product').baseUrl
    + this.config.getEndPoint(this.config.get('views'), StaticDataService.header_page_id, 'webengage_notificationtype')).subscribe((response) => {
        if(response){
          this.notificationType = response;
          this.selectedNotificationType = this.notificationType.filter(t => t.name === 'Banner');
          if(this.selectedNotificationType.length > 0){
            this.selectedNotificationTypeObject = this.selectedNotificationType[0];
          }
        }
    },(error)=>{
      console.log(error);
      //this.snotify.error('Error While fetching Notification Type', '', this.sharedService.getConfig(false));
    });
  }

  sendWebEngageNotification(){
    let url = '';
    let moengageUrl = '';
    this.webEngageResponse = false;
    this.moEngaeRespponse = false;
    this.mandatoryFieldUrl = false;
    this.mandatoryFieldStoryId = false;
    this.mandatoryFieldMessage = false;
    this.mandatoryImageUrl = false;
   if(this.notification){
     this.notification['tags'] = this.currentTagIds;
     this.notification['segments'] = this.currentSegmentIds;
     this.notification['moSegments'] = this.currentMoSegmentIds;
     this.notification['crossDomains'] = this.currentCrossDomainIds;
     this.notification['devices'] = this.selectedApplications.map(a => a.id);
     if(!this.notification['notificationTypeId'] && this.selectedNotificationTypeObject){
      this.notification['notificationTypeId'] = this.selectedNotificationTypeObject['id'];
     }
     if(this.selectedNotificationTypeObject['name'] === 'Breaking News Banner' || this.selectedNotificationTypeObject['name'] === 'Breaking News Text'){
      this.notification['flash'] = true;
     }
     if(this.selectedNotificationTypeObject['name'] === 'External'){
      this.notification['external'] = true;
     }
     if(this.selectedNotificationTypeObject && (this.selectedNotificationTypeObject['name'] === 'External' || this.selectedNotificationTypeObject['name'] === 'Breaking News Banner')){
      this.notification['storyId'] = '';
     }
     if(this.selectedNotificationTypeObject['name'] === 'Banner' || this.selectedNotificationTypeObject['name'] === 'Breaking News Banner') {
      this.notification['imageLayout'] = true;
     }
     if(!this.notification['devices'] || this.notification['devices'].length === 0){
      this.snotify.error('Please Select Target Application..', '', this.sharedService.getConfig(false));
      return;
    }
    if (this.notification && !this.notification['storyUrl'] && (this.selectedNotificationTypeObject['name'] === 'External' || this.selectedNotificationTypeObject['name'] === 'Video' || this.selectedNotificationTypeObject['name'] === 'Banner')) {
      this.snotify.error('Please Fill Url', this.sharedService.getConfig(false));
      this.mandatoryFieldUrl = true;
      return;
    }
    if (this.notification && !this.notification['storyId'] && (this.selectedNotificationTypeObject['name'] === 'Video' || this.selectedNotificationTypeObject['name'] === 'Banner')) {
      this.snotify.error('Please Fill StoryId', this.sharedService.getConfig(false));
      this.mandatoryFieldStoryId = true;
      return;
    }
    if(!this.notification['notificationTypeId']){
      this.snotify.error('Please Select NotificationType..', '', this.sharedService.getConfig(false));
      return;
    }
    if(!this.notification['title']){
      this.snotify.error('Please Fill Message..', '', this.sharedService.getConfig(false));
      this.mandatoryFieldMessage = true;
      return;
    }
    if (this.notification && !this.notification['imageUrl'] && this.selectedNotificationTypeObject['name'] === 'Banner') {
      this.snotify.error('Please Fill Image Url', this.sharedService.getConfig(false));
      this.mandatoryImageUrl = true;
      return;
    }
    if(this.notification['storyId']){
      url = this.config.get('product').baseUrl
      + this.config.getEndPoint(this.config.get('views'), StaticDataService.header_page_id, 'webengage_notify') + '?id=' + this.notification['storyId'];
      moengageUrl = this.config.get('product').baseUrl
      + this.config.getEndPoint(this.config.get('views'), StaticDataService.header_page_id, 'send_moengage_notification') + '?id=' + this.notification['storyId'];
    }else{
      url = this.config.get('product').baseUrl
      + this.config.getEndPoint(this.config.get('views'), StaticDataService.header_page_id, 'webengage_notify');
      moengageUrl = this.config.get('product').baseUrl
      + this.config.getEndPoint(this.config.get('views'), StaticDataService.header_page_id, 'send_moengage_notification');
    }
    if(!this.enableMoEngage && !this.enableWebEngage)
    {
      this.snotify.error('No Platform Is Enabled For Sending Notification', '', this.sharedService.getConfig(false));
      return;
    }
    if(!this.enableMoEngage)
    {
      this.moEngaeRespponse = true;
    }
    if(!this.enableCrossDomainNotification)
    {
      this.crossDomainRespponse = true;
    }
    if(!this.enableWebEngage)
    {
      this.webEngageResponse = true;
    }
    
     if (this.enableWebEngage) {
       this.http.post(url, this.notification).subscribe((response) => {
         this.webEngageResponse = true;
         if (this.moEngaeRespponse) {
           this.sendingNotificationDone();
         }
         this.snotify.success('WebEngage Notification Sent Successfully..', '', this.sharedService.getConfig(false));
       }, (error) => {
         this.webEngageResponse = true;
         // if(this.moEngaeRespponse)
         // {
         //   this.sendingNotificationDone();
         // }
         if (error.error === 'Duplicate Notification Headline') {
           console.log(error.error);
         } else
           this.snotify.error('Error While Sending WebEngage Notification', '', this.sharedService.getConfig(false));
       });
     }


     if (this.enableMoEngage) {
       this.http.post(moengageUrl, this.notification).subscribe((response) => {
         this.moEngaeRespponse = true;
         if (this.webEngageResponse) {
           this.sendingNotificationDone();
         }
         this.snotify.success('MoEngage Notification Sent Successfully..', '', this.sharedService.getConfig(false));
       }, (error) => {
         this.moEngaeRespponse = true;
         //  if(this.webEngageResponse)
         //  {
         //   this.sendingNotificationDone();
         //  }
         this.snotify.error('Error While Sending MoEngage Notification', '', this.sharedService.getConfig(false));
       });
     }
   }
  }

  sendingNotificationDone()
  {
    this.closesendNotifications();
    this.notification = {};
    this.selectedTags = [];
    this.selectedSegments = [];
  }

  fillStoryId(url: string) {
    let apiUrl = '';
    let data = {
    }
    if (url && url.includes('.html')) {
      data['storyId'] = url.split('.html')[0].split('-')[url.split('.html')[0].split('-').length - 1].trim();
      if(data['storyId'] && isNaN(data['storyId'])){
        apiUrl = this.config.get('product').baseUrl
        + this.config.getEndPoint(this.config.get('views'), StaticDataService.header_page_id, 'webengage_body') + '/old/' + data['storyId'];
      }else{
        apiUrl = this.config.get('product').baseUrl
        + this.config.getEndPoint(this.config.get('views'), StaticDataService.header_page_id, 'webengage_body') + '/' + data['storyId'];
      }
      this.http.get(apiUrl).subscribe((result) => {
       this.notification['storyId'] = result['id'];
       this.notification['imageUrl'] = result['leadImage'];
       if(result['title']){
         this.notification['title'] = result['title'];
       }
       if(result['section'])
       {
        this.notification['section'] = result['section'];
       }
      },
      (error)=> {});
    }
 }
 changeToggleEvent()
  {
     this.statusMenu = !this.statusMenu;
  }

  closeMobileMenu() {
    this.statusMenu = false;
  }
}
